import { Box, CircularProgress, Grid2, Typography } from '@mui/material';
import { useFormatting } from '../../utils/formatting';
import styled from '@emotion/styled';
import {
    useCompanyBalance,
    useCurrentCompanyDetails
} from '../../services/paymentsQuery';
import { TextDisplayMDSemiBold, TextMedium } from '../../typography/Typography';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { DashboardCard } from './common';

const BalanceList = styled('div')`
    display: flex;
    justify-content: space-between;
`;

export const CompanyBalance = () => {
    const { data: currentCompanyBalance, isPending } = useCompanyBalance();
    const { getBalanceLabelV2 } = useFormatting();

    return (
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 3.8 }}>
            <DashboardCard>
                {isPending && (
                    <Box mt={2} mr={10}>
                        <CircularProgress size={20} />
                    </Box>
                )}
                {!isPending && (
                    <>
                        <TextMedium textAlign={'left'}>
                            {t('available_balance')}
                        </TextMedium>
                        <TextDisplayMDSemiBold textAlign={'left'}>
                            {getBalanceLabelV2(
                                currentCompanyBalance?.data?.availableBalance,
                                currentCompanyBalance?.data?.currency ?? 'DKK',
                                { showNegativeStyle: true }
                            )}
                        </TextDisplayMDSemiBold>
                        <Typography
                            textAlign={'left'}
                            sx={{
                                fontFamily: 'Inter',
                                fontWeight: 700,
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: 0
                            }}
                        >
                            {getBalanceLabelV2(
                                currentCompanyBalance?.data
                                    ?.awaitingAdminApprovalTotal,
                                currentCompanyBalance?.data?.currency ?? 'DKK',
                                { showNegativeStyle: true }
                            )}{' '}
                            {t('pending_approval_label')}
                        </Typography>
                    </>
                )}
            </DashboardCard>
            <Box sx={{ clear: 'both' }}></Box>
        </Grid2>
    );
};
